import { Meta, metaFromResponse } from '../interfaces/Meta/Meta';
import api, { apiPrefix } from './Api';

export const getCategoryMeta = async (slug: string): Promise<Meta> => {
  const response = await api.get(`${apiPrefix}/categories/meta/${slug}`);

  return metaFromResponse(response.data?.data);
};
